
document.addEventListener('DOMContentLoaded', function() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('section-is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
  document.querySelectorAll('.shopify-section').forEach(function(section, i) {
    if (i > 0) observer.observe(section);
  });
  var header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 50) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }, { passive: true });
  }
});
